module.exports = __webpack_public_path__ + "static/circuitboard-f51c97d5576f65b1cdaa92d56fdebb95.png";